(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-stockists"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-stockist-filters]').forEach((filtersWrap) => {
      const stateSelect = filtersWrap.querySelector('[data-filter="state"]');
      const citySelect = filtersWrap.querySelector('[data-filter="city"]');
      const resetBtn = filtersWrap.querySelector('[data-reset]');
      const section = filtersWrap.closest('.nor-stockists');
      const items = section ? Array.from(section.querySelectorAll('.nor-stockist')) : [];
      if (!stateSelect || !citySelect || !resetBtn) return;

      const states = [];
      const cities = [];
      const stateSet = new Set();
      const citySet = new Set();
      const cityStateMap = {};
      items.forEach((item) => {
        const state = item.dataset.state;
        const city = item.dataset.city;
        if (state && !stateSet.has(state)) {
          stateSet.add(state);
          states.push(state);
        }
        if (city && !citySet.has(city)) {
          citySet.add(city);
          cities.push({ value: city, text: city });
        }
        if (city && state) {
          cityStateMap[city] = state;
        }
      });

      const populateSelect = (select, options) => {
        Array.from(select.querySelectorAll('option')).forEach((opt) => {
          if (opt.value !== '') opt.remove();
        });
        options.forEach((opt) => {
          const option = document.createElement('option');
          option.value = opt.value;
          option.textContent = opt.text;
          select.appendChild(option);
        });
      };

      const rebuildCities = (state) => {
        const filtered = state ? cities.filter((c) => cityStateMap[c.value] === state) : cities;
        populateSelect(citySelect, filtered);
        citySelect.value = '';
      };

      const apply = () => {
        const state = stateSelect.value;
        const city = citySelect.value;
        items.forEach((item) => {
          const matchState = !state || item.dataset.state === state;
          const matchCity = !city || item.dataset.city === city;
          item.classList.toggle('is-hidden', !(matchState && matchCity));
        });
        const active = state !== '' || city !== '';
        resetBtn.classList.toggle('is-hidden', !active);
      };

      populateSelect(stateSelect, states.map((s) => ({ value: s, text: s })));
      populateSelect(citySelect, cities);

      stateSelect.addEventListener('change', () => {
        rebuildCities(stateSelect.value);
        apply();
      });

      citySelect.addEventListener('change', apply);

      resetBtn.addEventListener('click', () => {
        stateSelect.value = '';
        rebuildCities('');
        apply();
      });

      apply();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-us"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const stage = document.querySelector('[data-about-stage]');
    if (!stage) return;
    const about = stage.closest('.nor-about');
    const textCol = about ? about.querySelector('.nor-about__col--text') : null;
    const pills = stage.querySelectorAll('[data-about-pill]');
    if (!textCol || pills.length < 2) return;

    const desktop = () => window.matchMedia('(min-width: 768px)').matches;
    let active = -1;
    let ticking = false;

    const setActive = (index) => {
      if (index === active) return;
      active = index;
      pills.forEach((pill, i) => pill.classList.toggle('is-active', i === index));
    };

    const update = () => {
      ticking = false;
      if (!desktop()) {
        setActive(0);
        return;
      }
      const rect = textCol.getBoundingClientRect();
      const vh = window.innerHeight;
      const total = rect.height - vh;
      const progress = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
      setActive(progress > 0.5 ? 1 : 0);
    };

    const requestUpdate = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.nor-announce__track').forEach((track) => {
      const slides = track.querySelectorAll('.nor-announce__slide');
      const rotate = track.dataset.announceRotate === 'true';
      const speed = parseInt(track.dataset.speed, 10) || 5;

      if (window.matchMedia('(max-width: 767px)').matches && slides.length > 1) {
        slides.forEach((slide) => {
          track.appendChild(slide.cloneNode(true));
        });
        track.classList.add('is-marquee');
        return;
      }

      if (slides.length < 2 || !rotate) return;

      let current = 0;
      setInterval(() => {
        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
      }, speed * 1000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-highlights"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-highlights]').forEach((section) => {
    const track = section.querySelector('[data-highlights-track]');
    const prev = section.querySelector('[data-highlights-prev]');
    const next = section.querySelector('[data-highlights-next]');
    if (!track || !prev || !next) return;

    const getGap = () => {
      const styles = window.getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap) || 0;
    };

    const updateArrows = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= maxScroll - 1;
    };

    const scrollByCard = (direction) => {
      const item = track.querySelector('.nor-grid__item');
      const itemWidth = item ? item.getBoundingClientRect().width : track.clientWidth;
      track.scrollBy({ left: (itemWidth + getGap()) * direction, behavior: 'smooth' });
    };

    prev.addEventListener('click', () => scrollByCard(-1));
    next.addEventListener('click', () => scrollByCard(1));
    track.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    updateArrows();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class NorieDrawerMenu {
    constructor() {
      this.drawer = document.querySelector('[data-drawer-menu]');
      this.openTriggers = document.querySelectorAll('[data-open-menu]');
      this.closeTriggers = this.drawer.querySelectorAll('[data-close-menu]');

      this.openTriggers.forEach((t) =>
        t.addEventListener('click', () => this.drawer.classList.add('is-open'))
      );
      this.closeTriggers.forEach((t) =>
        t.addEventListener('click', () => this.drawer.classList.remove('is-open'))
      );
    }
  }

  function initNorieHeader() {
    if (document.querySelector('[data-drawer-menu]')) new NorieDrawerMenu();

    const header = document.querySelector('.nor-header');
    const announce = document.querySelector('.nor-announce');
    if (!header) return;

    const applyLayout = () => {
      const announceHeight = announce ? announce.offsetHeight : 34;
      header.style.top = announceHeight + 'px';
      document.body.style.paddingTop = announceHeight + header.offsetHeight + 'px';
      document.documentElement.style.setProperty(
        '--n-header-h',
        announceHeight + header.offsetHeight + 'px'
      );
    };

    applyLayout();
    window.addEventListener('resize', applyLayout);

    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 0);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNorieHeader);
  } else {
    initNorieHeader();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-quantity]').forEach((wrapper) => {
    const input = wrapper.querySelector('input[name="quantity"]');
    const minus = wrapper.querySelector('[data-minus]');
    const plus = wrapper.querySelector('[data-plus]');
    if (!input) return;
    minus.addEventListener('click', () => {
      const value = parseInt(input.value, 10) || 1;
      if (value > 1) input.value = value - 1;
    });
    plus.addEventListener('click', () => {
      const value = parseInt(input.value, 10) || 0;
      input.value = value + 1;
    });
  });

  // Gallery logic (thumbs + main image, hover on desktop / tap on touch)
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const slides = gallery.querySelectorAll('[data-slide-index]');
    const thumbs = gallery.querySelectorAll('[data-thumb-index]');
    if (slides.length === 0) return;

    slides.forEach((slide) => {
      const img = slide.querySelector('img');
      if (img && !img.complete && img.src) {
        const preload = new Image();
        preload.src = img.src;
      }
    });

    const touchDevice = window.matchMedia('(hover: none)').matches;
    let activeIndex = 0;
    let progressRaf = null;
    let progressStart = null;
    let inView = false;
    let hovered = false;
    let tabHidden = false;
    const AUTO_INTERVAL = 5000;
    const getNextIndex = () => (activeIndex + 1) % thumbs.length;
    if (thumbs.length > 1) thumbs[getNextIndex()].classList.add('is-next');

    const setProgress = (fraction) => {
      thumbs.forEach((thumb, i) => {
        thumb.style.setProperty('--p', i === getNextIndex() ? String(fraction) : '0');
      });
    };

    const activate = (index) => {
      if (index === activeIndex) return;

      slides.forEach((slide, i) => {
        const isActive = i === index;
        slide.classList.toggle('is-active', isActive);
        const video = slide.querySelector('video');
        if (!video) return;
        if (isActive) {
          video.muted = true;
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });

      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
        thumb.classList.toggle('is-next', thumbs.length > 1 && i === (index + 1) % thumbs.length);
        if (i === index) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });

      activeIndex = index;
      setProgress(0);
    };

    const advance = () => {
      activate((activeIndex + 1) % slides.length);
      startProgress();
    };

    const tick = (now) => {
      if (progressStart === null) progressStart = now;
      const fraction = Math.min((now - progressStart) / AUTO_INTERVAL, 1);
      setProgress(fraction);
      if (fraction < 1) {
        progressRaf = requestAnimationFrame(tick);
      } else {
        advance();
      }
    };

    const startProgress = () => {
      if (progressRaf) cancelAnimationFrame(progressRaf);
      progressRaf = null;
      progressStart = null;
      setProgress(0);
      progressRaf = requestAnimationFrame(tick);
    };

    const stopProgress = () => {
      if (progressRaf) cancelAnimationFrame(progressRaf);
      progressRaf = null;
      progressStart = null;
    };

    const startAuto = () => {
      stopProgress();
      startProgress();
    };

    const stopAuto = () => stopProgress();

    const shouldRun = () => slides.length > 1 && inView && !hovered && !tabHidden;

    const syncAuto = () => {
      if (shouldRun()) startAuto();
      else stopAuto();
    };

    if (slides.length > 1) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          inView = entry.isIntersecting;
          syncAuto();
        });
      }, { threshold: 0.2 });
      observer.observe(gallery);

      gallery.addEventListener('mouseenter', () => {
        hovered = true;
        syncAuto();
      });
      gallery.addEventListener('mouseleave', () => {
        hovered = false;
        syncAuto();
      });
      document.addEventListener('visibilitychange', () => {
        tabHidden = document.hidden;
        syncAuto();
      });
    }

    thumbs.forEach((thumb) => {
      const index = parseInt(thumb.dataset.thumbIndex, 10);
      thumb.addEventListener('click', () => {
        activate(index);
        if (shouldRun()) startProgress();
      });
      if (!touchDevice) {
        thumb.addEventListener('mouseenter', () => activate(index));
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  class NorieNewsletterPopup {
    constructor(modal) {
      this.modal = modal;
      this.closeBtn = modal.querySelector('.popup-newsletter__close');
      this.autoOpen = modal.dataset.autoOpen === 'true';
      this.delay = parseInt(modal.dataset.delay, 10) || 0;
      this.storageKey = 'norie_newsletter_shown';
      this.success = modal.querySelector('[data-newsletter-success]');
      this.formWrap = modal.querySelector('[data-newsletter-form]');
      this.form = modal.querySelector('.popup-newsletter__form');
      this.submit = modal.querySelector('[data-newsletter-submit]');
      this.submitText = modal.querySelector('[data-newsletter-submit-text]');
      this.errorEl = modal.querySelector('[data-newsletter-error]');
      this.defaultLabel = this.submitText ? this.submitText.textContent : '';
      this.init();
    }

    init() {
      this.bindClose();
      this.bindSubmit();
      this.bindSafetyNet();
      this.bindLinks();

      if (sessionStorage.getItem('norie_newsletter_success')) {
        this.open();
        this.showSuccess();
        sessionStorage.removeItem('norie_newsletter_success');
        return;
      }

      const params = new URLSearchParams(window.location.search);
      if (params.get('newsletter') === 'true') {
        this.open();
        const url = new URL(window.location.href);
        url.searchParams.delete('newsletter');
        window.history.replaceState({}, '', url.toString());
        return;
      }

      if (
        !this.modal.classList.contains('is-open') &&
        this.autoOpen &&
        !localStorage.getItem(this.storageKey)
      ) {
        setTimeout(() => {
          this.open();
          localStorage.setItem(this.storageKey, 'true');
        }, this.delay * 1000);
      }
    }

    bindClose() {
      this.closeBtn.addEventListener('click', () => this.close());
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) this.close();
      });
      document.addEventListener('keydown', (e) => {
        if (!this.modal.classList.contains('is-open')) return;
        if (e.key === 'Escape') {
          this.close();
          return;
        }
        if (e.key === 'Tab') this.trapFocus(e);
      });
    }

    bindSubmit() {
      if (this.form) {
        this.form.addEventListener('submit', (e) => this.handleSubmit(e));
        const input = this.form.querySelector('input[name="contact[email]"]');
        if (input) {
          input.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              this.handleSubmit(e);
            }
          });
        }
      }
      if (this.submit) {
        this.submit.addEventListener('click', () => this.handleSubmit());
      }
    }

    bindSafetyNet() {
      document.addEventListener(
        'submit',
        (e) => {
          if (e.target && e.target === this.form) e.preventDefault();
        },
        true
      );
    }

    async handleSubmit(e) {
      if (e && e.preventDefault) e.preventDefault();
      const email = this.form ? this.form.querySelector('input[name="contact[email]"]') : null;
      const value = email ? email.value.trim() : '';
      if (!value) return;

      this.setLoading(true);
      this.setError('');

      const frameName = 'norie-newsletter-frame-' + Date.now();
      const iframe = document.createElement('iframe');
      iframe.name = frameName;
      iframe.style.display = 'none';
      iframe.style.position = 'absolute';
      iframe.setAttribute('tabindex', '-1');
      iframe.setAttribute('aria-hidden', 'true');
      iframe.setAttribute('sandbox', 'allow-same-origin allow-scripts allow-forms');

      const timeout = setTimeout(() => {
        iframe.remove();
        this.setLoading(false);
        this.setError(this.modal.dataset.errorMessage || '');
      }, 15000);

      iframe.addEventListener('load', () => {
        clearTimeout(timeout);
        this.setLoading(false);
        try {
          const frameDoc = iframe.contentDocument || iframe.contentWindow.document;
          const frameUrl = iframe.contentWindow.location.href || '';
          const success = frameUrl.indexOf('customer_posted=true') !== -1;
          if (success) {
            this.showSuccess();
            iframe.remove();
            return;
          }
          const errEl = frameDoc.querySelector(
            '.popup-newsletter__error, .form__message--error, .errors, #contact_form .errors'
          );
          if (errEl && errEl.textContent && errEl.textContent.trim()) {
            this.setError(errEl.textContent.trim());
          } else {
            this.showSuccess();
          }
        } catch (err) {
          this.setError(this.modal.dataset.errorMessage || '');
        } finally {
          iframe.remove();
        }
      });

      document.body.appendChild(iframe);
      this.form.target = frameName;
      this.form.submit();
      this.form.removeAttribute('target');
    }

    setLoading(loading) {
      if (!this.submit) return;
      this.submit.disabled = loading;
      if (this.submitText) {
        this.submitText.textContent = loading
          ? this.modal.dataset.loadingLabel || this.defaultLabel
          : this.defaultLabel;
      }
    }

    setError(message) {
      if (!this.errorEl) return;
      if (message) {
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
      } else {
        this.errorEl.textContent = '';
        this.errorEl.hidden = true;
      }
    }

    showSuccess() {
      if (!this.success || !this.formWrap) return;
      this.formWrap.hidden = true;
      this.success.hidden = false;
      sessionStorage.setItem('norie_newsletter_success', '1');
      const code = this.success.querySelector('.popup-newsletter__code');
      if (code) code.focus();
    }

    bindLinks() {
      document.querySelectorAll('a[href*="newsletter=true"]').forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });
    }

    trapFocus(e) {
      const focusable = this.modal.querySelectorAll(
        'button, input, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    open() {
      this.modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      const input = this.modal.querySelector('input[type="email"]');
      if (input) input.focus();
    }

    close() {
      this.modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  document.querySelectorAll('.popup-newsletter').forEach((modal) => {
    new NorieNewsletterPopup(modal);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-marquee"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-draggable-scroll]').forEach((track) => {
      const marquee = track.closest('.nor-marquee');

      let isDown = false;
      let lastX = 0;
      let paused = false;
      let raf = null;
      let lastTime = null;
      const speed = 50;

      const setWidth = () => {
        const sets = track.querySelectorAll('.nor-marquee__set');
        return sets.length ? sets[0].offsetWidth : 0;
      };

      const tick = (ts) => {
        if (lastTime == null) lastTime = ts;
        const dt = (ts - lastTime) / 1000;
        lastTime = ts;
        if (!paused && !isDown) {
          const sw = setWidth();
          if (sw > 0) {
            const trackEnd = marquee.scrollWidth - marquee.clientWidth;
            const trigger = Math.min(2 * sw, Math.max(trackEnd - 1, 0));
            if (marquee.scrollLeft >= trigger) {
              marquee.scrollLeft -= sw;
            }
          }
          marquee.scrollLeft += speed * dt;
        }
        raf = requestAnimationFrame(tick);
      };

      marquee.addEventListener('mouseenter', () => {
        paused = true;
      });
      marquee.addEventListener('mouseleave', () => {
        paused = false;
      });

      track.addEventListener('mousedown', (e) => {
        if (e.button !== 0) return;
        const rect = marquee.getBoundingClientRect();
        if (e.clientY - rect.top >= marquee.clientHeight) return;
        isDown = true;
        marquee.classList.add('is-dragging');
        lastX = e.pageX;
      });

      document.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        marquee.scrollLeft -= e.pageX - lastX;
        lastX = e.pageX;
      });

      document.addEventListener('mouseup', () => {
        if (!isDown) return;
        isDown = false;
        marquee.classList.remove('is-dragging');
      });

      raf = requestAnimationFrame(tick);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
